var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0001({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "compress",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-tab",
    id: "Shape",
    d: "M11.384,15H10.045a.4.4,0,0,1-.4-.4V10.446a.8.8,0,0,1,.8-.8H14.6a.4.4,0,0,1,.4.4v1.339a.4.4,0,0,1-.4.4H11.786V14.6A.4.4,0,0,1,11.384,15ZM4.955,15H3.616a.4.4,0,0,1-.4-.4V11.786H.4a.4.4,0,0,1-.4-.4V10.045a.4.4,0,0,1,.4-.4H4.554a.8.8,0,0,1,.8.8V14.6A.4.4,0,0,1,4.955,15ZM14.6,5.357H10.446a.8.8,0,0,1-.8-.8V.4a.4.4,0,0,1,.4-.4h1.339a.4.4,0,0,1,.4.4V3.214H14.6a.4.4,0,0,1,.4.4V4.955A.4.4,0,0,1,14.6,5.357Zm-10.044,0H.4a.4.4,0,0,1-.4-.4V3.616a.4.4,0,0,1,.4-.4H3.214V.4a.4.4,0,0,1,.4-.4H4.955a.4.4,0,0,1,.4.4V4.554A.8.8,0,0,1,4.554,5.357Z",
    fill: "#738490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0001);
export default __webpack_public_path__ + "static/media/0001.478a519d2ee47edeefb2e851e51064e0.svg";
export { ForwardRef as ReactComponent };